const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/34640877479"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:bg-[#20BA5A] transition-all hover:scale-110 cursor-pointer"
      aria-label="Contactar por WhatsApp"
    >
      <div className="w-7 h-7 flex items-center justify-center">
        <i className="ri-whatsapp-fill text-white text-3xl"></i>
      </div>
    </a>
  );
};

export default WhatsAppButton;
